import {HttpRequest,HttpMethod} from "./http";

class PackingProvider extends HttpRequest {

	// CRUD Packing
	PackingCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/packings`,params );
	}

	PackingList(params) {
		return this.request(HttpMethod.Get,`/api/v1/packings`,params );
	}

	PackingDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/packings/${id}`);
	}

	PackingShipping(params) {
		return this.request(HttpMethod.Post,`/api/v1/packings/print` ,params);
	}

	PackingGetDocument(params) {
		return this.request(HttpMethod.Get,`/api/v1/packings/print` ,params);
	}

	PackingGetDocumentV2(params) {
		return this.request(HttpMethod.Get,`/api/v2/packings/print` ,params);
	}

	PickupItemAdd(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/verify/createoradd` ,params);
	}

	ShippingCreateAndClose(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/verify/createandclose` ,params);
	}

	ShippingCreateAndCloseWithCoupon(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/verify/createandclose_with_coupon` ,params);
	}

	ShippingLinkCoupon(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/verify/linkcoupon` ,params);
	}

	ShippingCheckIsClose(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/check/isclosed` ,params);
	}

	PickupItemRemove(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/verify/remove` ,params);
	}

	ShippingClose(params) {
		return this.request(HttpMethod.Post,`/api/v3/packings/verify/close` ,params);
	}

	ReturnCreate(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/return/create` ,params);
	}

	ReturnClose(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/return/close` ,params);
	}


	AdminPickupItemAdd(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/adminverify/createoradd` ,params);
	}

	AdminPickupItemClear(params) {
		return this.request(HttpMethod.Post,`/api/v2/packings/adminverify/delete` ,params);
	}

	AdminShippingClose(params) {
		return this.request(HttpMethod.Post,`/api/v3/packings/adminverify/close` ,params);
	}

	ClearFailTracking(id) {
		return this.request(HttpMethod.Put,`/api/v1/packings/clearfailtracking/${id}`);
	}

	PackingGenerateTracking(params) {
		return this.request(HttpMethod.Get,`/api/v1/packings/tracking`,params);
	}

	// Spec 2026-10-14 §3.2 #1: the round's orders without a tracking number +
	// the last failure reason. params: { bo_packing_id }
	trackingFailures(params) {
		return this.request(HttpMethod.Get,`/api/v1/packings/tracking-failures`,params);
	}

	// §3.2 #2: re-mint under the round's GET_LOCK (409 errors.tracking_in_progress).
	// payload: { bo_packing_id, order_ids } (order_ids optional, ≤ 100)
	trackingRetry(payload) {
		return this.request(HttpMethod.Post,`/api/v1/packings/tracking-retry`,payload);
	}


}

export default PackingProvider